<template>
  <v-container ma-0 pa-0 fluid style="height:100%;" class="pt-sans">
    <v-layout row wrap style="height:100%;">
      <v-flex sm3 hidden-sm-and-down>
        <div class="" style="height:100%;background-color:#ea1d24;">
          <img src="../../assets/img-cadastro.png" alt="" class="img-responsive">
          <div class="destaque-cadastro">
            <img src="../../assets/icone-cadastro.png" alt="">
            <h5>
                Cadastre e veja seu negócio crescer!
            </h5>
            <h6>
              Venda mais para Condomínios! Conheça a ferramenta que coloca sua empresa em contato com quem compra!
            </h6>
          </div>
        </div>
      </v-flex>
      <v-flex xs12 sm12 md9 class="no-bar ajuste-scroll">
        <v-slide-x-transition mode="out-in">
          <v-flex xs12 md10 class="no-bar posCadastro">
            <v-container grid-list-sm grid-list-md v-show="cadastroCompleto">
              <v-layout row wrap>
                <v-flex xs12>
                  <h3>
                    Olá, {{ nomeCompleto }}
                  </h3>
                  <div class="">
                    enviaremos em instantes um e-mail para <br>
                    <span class="email-vermelho">{{ email }}</span>, para confirmar seu cadastro.
                  </div>
                  <div class="">
                    se não chegou ainda, aguarde um pouquinho.
                  </div>
                  <div class="">
                    Equipe, Condoplaza
                  </div>
                  <div class="">
                    <v-btn
                       round
                       large
                       class="btn-red"
                       v-on:click='toLogin'
                       dark
                    >
                      Finalizar
                    </v-btn>
                  </div>
                </v-flex>
              </v-layout>
            </v-container>
          </v-flex>
        </v-slide-x-transition>
        <v-slide-x-transition mode="out-in">
          <v-flex xs12 md10 class="no-bar">
          <v-container grid-list-sm grid-list-md v-show="!cadastroCompleto">
            <v-layout row wrap>
              <v-flex xs12 style="position:relative;">
                <router-link to="/Login" class="voltar"><v-icon x-large>keyboard_arrow_left</v-icon></router-link>
                <h4 class="titulo">Cadastre seu negócio</h4>
              </v-flex>
            </v-layout>
            <v-form v-model="formValido" ref="form" name="form-cadastro" value="true">
              <v-layout row wrap>
                  <v-flex xs12 sm6 md6>
                    <v-text-field
                      label="Nome do seu negócio"
                      hint="Nome fantasia"
                      v-model="nomeFantasia"
                      :rules="nomeFantasiaRegras"
                      :count="60"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-text-field
                      label="Documento"
                      hint="CPF/CNPJ"
                      v-model="mascaraDocumento"
                      :rules="documentoRegras"
                      :validate-on-blur="true"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-text-field
                      label="Seu nome completo"
                      v-model="nomeCompleto"
                      :rules="nomeCompletoRegras"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md3>
                    <v-text-field
                      label="Telefone do seu Negócio"
                      v-model="mascaraTelefone"
                      hint="DDD + Numero"
                      persistent-hint
                      :rules="telefoneRegras"
                      :validate-on-blur="true"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md3>
                    <v-text-field
                      label="E-mail do seu Negócio"
                      v-model="email"
                      :rules="emailRegras"
                      :validate-on-blur="true"
                      required
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                  <v-layout row wrap>
                    <v-flex xs12 sm6 md4>
                      <v-text-field
                        label="Usuário"
                        v-model="usuario"
                        :rules="usuarioRegras"
                        :validate-on-blur="true"
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm4 md4>
                      <v-text-field
                        label="Senha"
                        type="password"
                        v-model="senha"
                        :rules="senhaRegras"
                        :validate-on-blur="true"
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm4 md4>
                      <v-text-field
                        label="Confirme a Senha"
                        type="password"
                        v-model="senhaComparacao"
                        :rules="senhaComparacaoRegras"
                        :validate-on-blur="true"
                        required
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs12 sm12 md12>
                      <tabela-classes></tabela-classes>
                    </v-flex>
                    <v-flex xs12 sm12 md12>
                      <v-checkbox
                         v-model="termosDeUso"
                         class="ajuste"
                         required
                      >
                         <div slot="label" class="">
                           <div>Sou representante legal do negócio e li e aceito os</div> <TermoLegal/> e os <TermoUso/>
                         </div>
                      </v-checkbox>
                    </v-flex>
                    <v-flex xs12 sm12 md12>
                      <v-btn
                         round
                         large
                         :loading="loading"
                         @click.native="loader = 'loading'"
                         :disabled="loading"
                         v-on:click='cadastrar'
                         class="btn-green"
                         dark
                      >
                       Cadastrar
                       <span slot="loader" class="custom-loader">
                         <v-icon light>cached</v-icon>
                       </span>
                      </v-btn>
                  </v-flex>
               </v-layout>
              </v-form>
            </v-container>
          </v-flex>
        </v-slide-x-transition>

      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import TabelaClasses from '@/components/tabelaClasses/'
import TermoLegal from './TermoLegal'
import TermoUso from './TermoDeUso'

export default {
  name: 'Cadastro',
  components: {
    TabelaClasses,
    TermoLegal,
    TermoUso
  },
  data () {
    return {
      cadastroCompleto: false,
      loading: false,
      termosDeUso: false,
      formValido: false,
      nomeFantasia: '',
      nomeFantasiaRegras: [
        (v) => !!v || 'Nome em branco',
        (v) => v.length < 61 || 'Nome fantasia inválido',
        (v) => v.length > 2 || 'Precisa conter no minimo 3 caracteres'
      ],
      documento: '',
      documentoRegras: [
        (v) => !!v || 'Documento em branco',
        (v) => v.length < 19 || 'Documento inválido',
        (v) => this.validaDocumento(v) || 'Documento inválido'
      ],
      nomeCompleto: '',
      nomeCompletoRegras: [
        (v) => !!v || 'Nome em branco'
      ],
      telefone: '',
      telefoneRegras: [
        (v) => !/[^0-9()-\W]{1,15}/.test(v) || 'Telefone inválido',
        (v) => !!v || 'Telefone em branco',
        (v) => v.length < 16 || 'Telefone inválido',
        (v) => v.length > 13 || 'Telefone inválido'
      ],
      email: '',
      emailRegras: [
        (v) => !!v || 'E-mail em branco',
        (v) => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(.\w{2,3})+$/.test(v) || 'E-mail inválido'
      ],
      usuario: '',
      usuarioRegras: [
        (v) => !!v || 'Usuario em branco',
        (v) => /^\S*$/.test(v) || 'Espaço não permitido',
        (v) => v.length < 20 || 'Usuario inválido'
      ],
      senha: '',
      senhaRegras: [
        (v) => !!v || 'Preencha uma senha',
        (v) => v.length > 5 || 'A senha deve ter no mínimo 6 caracteres'
      ],
      senhaComparacao: '',
      senhaComparacaoRegras: [
        (v) => !!v || 'Preencha uma senha',
        (v) => this.senha === v || 'As senhas não são iguais'
      ]
    }
  },
  computed: {
    mascaraTelefone: {
      get: function () {
        return this.telefone
      },
      set: function (newValue) {
        if (/[^0-9()-\W]{1,15}/.test(newValue) || newValue.length > 15) {
          this.resetMascara()
          return
        }
        newValue = newValue.replace(/\D/g, '')
        newValue = newValue.replace(/^(\d{2})(\d)/g, '($1) $2')
        newValue = newValue.replace(/(\d)(\d{4})$/, '$1-$2')
        setTimeout(() => {
          this.telefone = newValue
        }, 1)
      }
    },
    mascaraDocumento: {
      get: function () {
        return this.documento
      },
      set: function (newValue) {
        if (/[^0-9./-\W]{1,18}/.test(newValue) || newValue.length > 18) {
          this.resetMascaraDocumento()
          return
        }
        newValue = newValue.replace(/\D/g, '')
        if (newValue.length <= 11) {
          newValue = newValue.replace(/(\d{3})(\d)/, '$1.$2')
          newValue = newValue.replace(/(\d{3})(\d)/, '$1.$2')
          newValue = newValue.replace(/(\d{3})(\d{1,2})$/, '$1-$2')
        } else {
          newValue = newValue.replace(/^(\d{2})(\d)/, '$1.$2')
          newValue = newValue.replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
          newValue = newValue.replace(/\.(\d{3})(\d)/, '.$1/$2')
          newValue = newValue.replace(/(\d{4})(\d)/, '$1-$2')
        }
        setTimeout(() => {
          this.documento = newValue
        }, 1)
      }
    }
  },
  methods: {
    toLogin () {
      this.$router.push('/Login/')
      return
    },
    validaDocumento: function (numero) {
      numero = numero.replace(/\D/g, '')
      if (numero.length === 11) {
        let cpf = numero
        let Soma = 0
        var Resto = 0
        if (cpf === '00000000000' ||
        cpf === '11111111111' ||
        cpf === '22222222222' ||
        cpf === '33333333333' ||
        cpf === '44444444444' ||
        cpf === '55555555555' ||
        cpf === '66666666666' ||
        cpf === '77777777777' ||
        cpf === '88888888888' ||
        cpf === '99999999999') {
          return false
        }
        for (let i = 1; i <= 9; i++) {
          Soma = Soma + parseInt(cpf.substring(i - 1, i)) * (11 - i)
        }
        Resto = (Soma * 10) % 11

        if ((Resto === 10) || (Resto === 11)) {
          Resto = 0
        }
        if (Resto !== parseInt(cpf.substring(9, 10))) {
          return false
        }
        Soma = 0
        for (let i = 1; i <= 10; i++) {
          Soma = Soma + parseInt(cpf.substring(i - 1, i)) * (12 - i)
        }
        Resto = (Soma * 10) % 11
        if ((Resto === 10) || (Resto === 11)) {
          Resto = 0
        }
        if (Resto !== parseInt(cpf.substring(10, 11))) {
          return false
        }
        return true
      } else if (numero.length === 14) {
        let cnpj = numero
        if (cnpj === '00000000000000' ||
        cnpj === '11111111111111' ||
        cnpj === '22222222222222' ||
        cnpj === '33333333333333' ||
        cnpj === '44444444444444' ||
        cnpj === '55555555555555' ||
        cnpj === '66666666666666' ||
        cnpj === '77777777777777' ||
        cnpj === '88888888888888' ||
        cnpj === '99999999999999') {
          return false
        }
        let tamanho = cnpj.length - 2
        let numeros = cnpj.substring(0, tamanho)
        let digitos = cnpj.substring(tamanho)
        let soma = 0
        let pos = tamanho - 7
        for (let i = tamanho; i >= 1; i--) {
          soma += numeros.charAt(tamanho - i) * pos--
          if (pos < 2) {
            pos = 9
          }
        }
        let resultado = soma % 11 < 2 ? 0 : 11 - soma % 11
        if (resultado !== parseInt(digitos.charAt(0))) {
          return false
        }
        tamanho = tamanho + 1
        numeros = cnpj.substring(0, tamanho)
        soma = 0
        pos = tamanho - 7
        for (let i = tamanho; i >= 1; i--) {
          soma += numeros.charAt(tamanho - i) * pos--
          if (pos < 2) {
            pos = 9
          }
        }
        resultado = soma % 11 < 2 ? 0 : 11 - soma % 11
        if (resultado !== parseInt(digitos.charAt(1))) {
          return false
        }
      } else {
        return false
      }
      return true
    },
    resetMascara: function () {
      let original = this.telefone
      this.telefone = this.telefone + ' '
      setTimeout(() => {
        this.telefone = original
      }, 1)
    },
    resetMascaraDocumento: function () {
      let original = this.documento
      this.documento = this.documento + ' '
      setTimeout(() => {
        this.documento = original
      }, 1)
    },
    cadastrar: function (event) {
      this.$refs.form.validate()
      if (!this.termosDeUso) {
        this.$store.commit('toastr', {
          color: 'error',
          texto: 'Aceite os termos de uso'
        })
        return
      }
      if (this.$store.getters.arrayCategorias.length === 0) {
        this.$store.commit('toastr', {
          color: 'error',
          texto: 'Selecione uma categoria do seu negócio'
        })
        return
      }
      if (!this.formValido) {
        // this.$store.commit('toastr', {
        //   color: 'error',
        //   texto: 'Campos inválidos'
        // })
        return
      }

      this.loading = true

      // ajuste para o back end
      let telefone = this.telefone.replace(/\D/g, '')
      let ddd = telefone.substring(0, 2)
      let numero = telefone.substring(2, telefone.length)
      this.$http.post('PreCadastro/Salvar', {
        Fantasia: this.nomeFantasia,
        Pessoa: this.documento.length === 18 ? 'J' : 'F',
        Documento: this.documento.replace(/\D/g, ''),
        Email: this.email,
        Ddd: ddd,
        Telefone: numero,
        NomeCompleto: this.nomeCompleto,
        NomeUsuario: this.usuario,
        Senha: this.senha,
        Categorias: this.$store.getters.arrayCategorias
      })
      .then((response) => {
        let data = response.data.resultado
        if (data.code === 200) {
          // store TOKEN
          this.cadastroCompleto = true
          this.$store.commit('toastr', {
            color: 'success',
            texto: 'Informações enviadas'
          })
          this.cadastroCompleto = true
        } else {
          this.$store.commit('toastr', {
            color: 'error',
            texto: data.mensagem
          })
        }
        this.loading = false
      })
      .catch(() => {
        this.$store.commit('toastr', {
          color: 'error',
          texto: 'Erro de conecxão'
        })
        this.loading = false
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.pt-sans{
  font-family: 'PT Sans', sans-serif!important;
}
.ajuste label{
  white-space: normal;
  height: 70px;
  line-height: 20px;
}
.ajuste label:after{
  content: ''
}

.voltar{
  position: relative;
  left: -13px;
}
.voltar i{
  color: #e51b2e!important;
}
.voltar i:hover{
  opacity: 0.8;
  color: #d62939!important;
  transition: opacity .2s, color .2s;
}
.titulo{
  display: inline;
  position: relative;
  top: 7px;
}
.destaque-cadastro{
  color: #f3fdfe;
  padding: 30px;
}
.destaque-cadastro img{
  float: left;
  width: 60px;
}
.destaque-cadastro h5{
  float: left;
  width: calc(100% - 60px);
  padding: 0 10px;
  font-weight: bold;
}
.destaque-cadastro h6{
  float: left;
  width: 100%;
}
@media only screen and (max-width: 643px){
  .box{
    width: 100%!important;
  }
  .ajuste {
      margin-bottom: 50px;
  }
  .ajuste label>div>div {
      display: inline;
  }
  .ajuste label {
      white-space: normal;
      height: 100px;
      line-height: 20px;
      max-width: 90%!important;
  }
  .titulo{
    position: absolute;
    left: 50%;
    margin-left: -98px;
    top: inherit;
  }
}
@media only screen and (min-width: 960px){
  .ajuste-scroll{
    padding: 0 8.333333333333332%;
  }
.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
.posCadastro{
  position: absolute;
  top: 50%;
  margin-top: -250px;
  left: 50%;
  margin-left: -250px;
}
</style>



// WEBPACK FOOTER //
// index.vue?1d726b36